<template>
  <div class="skeleton-portal">
    <slot v-if="contentLoaded" />
    <slot v-else-if="$slots.skeleton" name="skeleton" />
    <component :is="componentIs" v-bind="$attrs" v-else-if="!!componentIs" />
  </div>
</template>
<script lang="ts" setup>
import { type Component } from "vue";

const props = defineProps<{
  contentLoaded: boolean;
  skeletonComponent?: Component | ReturnType<typeof defineAsyncComponent>;
}>();

const componentIs = computed(() => props.skeletonComponent);
</script>
